export const Roles = {
  ONEGRAD_HERO: "ONEGRAD_HERO",
  ONEGRAD_SENIOR: "ONEGRAD_SENIOR",
  ONEGRAD_COUNSELOR: "ONEGRAD_COUNSELOR",
  ONEGRAD_COLLEGE_REP: "ONEGRAD_COLLEGE_REP",
};

export const OpenToMentor = "Open To Mentor";